import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const PlaySVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default PlaySVG;
